import * as React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {useEffect, useState} from 'react';
import {useCookies} from 'react-cookie';
import WarehouseService from '../../shared/services/WarehouseService';
import BatchWavingService from '../../shared/services/BatchWavingService';
import WaveTemplateService from '../../shared/services/WaveTemplateService';
import {CompanyType, Warehouse} from '../../shared/CommonInterfaces';
import FlexeContext, {FlexeContextValues} from '../../contexts/FlexeContext';
import AsyncWaving from '../batch-waving/AsyncWaving';
import useSearchParams from '../../shared/useSearchParams';

interface BatchesProps {
  authenticityToken: string;
  carriers: object;
  currentWarehouse: Warehouse;
  warehouses: Warehouse[];
  reservationToSortationEnabled: object;
  hasWhManagerBillingPerms: boolean;
  highVolumeWavingMap: object;
  whCancelShipmentEnabled: boolean;
  useExactDateForShipByDate: boolean;
}

function Batches(props: BatchesProps) {
  const warehouseService = new WarehouseService(props.authenticityToken);
  const batchService = new BatchWavingService(props.authenticityToken);
  const waveTemplateService = new WaveTemplateService(props.authenticityToken);
  const [selectedWarehouse, setSelectedWarehouse] = useState<Warehouse>(props.currentWarehouse);
  batchService.currentWarehouse = Number(selectedWarehouse.id);
  const flexeContextValue: FlexeContextValues = {
    authenticityToken: props.authenticityToken
  };

  const [isFullPalletPullForSortationEnabled, setIsFullPalletPullForSortationEnabled] = useState<boolean>(false);
  const {searchParams} = useSearchParams();
  const [cookies, _setCookie, _removeCookie] = useCookies(['selected_warehouse_id']);

  const getFeatureFlagValue = async (flag: string, warehouseId: number = null, reservationId: number = null) => {
    const featureFlagResponse = await warehouseService.getFeatureFlag(flag, warehouseId, reservationId);
    return !!featureFlagResponse.data.value;
  };

  const updateWarehouseFeatureFlagsAsync = async (warehouseId: number) => {
    const fullPalletPullForSortation = getFeatureFlagValue('full_pallet_pull_for_sortation', warehouseId, null);

    setIsFullPalletPullForSortationEnabled(await fullPalletPullForSortation);
  };

  useEffect(() => {
    // Feature Flags
    updateWarehouseFeatureFlagsAsync(props.currentWarehouse.id);
  }, []);

  useEffect(() => {
    if (cookies.selected_warehouse_id && cookies.selected_warehouse_id !== selectedWarehouse.id.toString()) {
      window.location.href = `/wh/fulfillment/ecommerce/waving?warehouse_id=${cookies.selected_warehouse_id}`;
    }
  }, [cookies]);

  const getHighVolumeWavingEnabled = () => {
    const warehouseId = selectedWarehouse.id;
    return props.highVolumeWavingMap[warehouseId];
  };

  return (
    <FlexeContext.Provider value={flexeContextValue}>
      <Router>
        <Switch>
          <Route
            path="/wh/fulfillment/ecommerce/waving"
            exact
            strict
            render={(routeProps) => (
              <AsyncWaving
                selectedWarehouse={selectedWarehouse}
                {...routeProps}
                {...props}
                reservationToSortationEnabled={props.reservationToSortationEnabled}
                carriers={props.carriers}
                isHighVolumeWavingEnabled={getHighVolumeWavingEnabled()}
                isFullPalletPullForSortationEnabled={isFullPalletPullForSortationEnabled}
                waveTemplateService={waveTemplateService}
                batchWavingService={batchService}
                warehouseService={warehouseService}
                useExactDateForShipByDate={props.useExactDateForShipByDate}
              />
            )}
          />
        </Switch>
      </Router>
    </FlexeContext.Provider>
  );
}

export default Batches;
